import { useContext, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { AuthContext } from "../services/context";
import { getCurrentWorkspace } from "../services/userConfig";
import SurveyTable from "../components/Surveys/SurveyTable";
import { useGetSurveys } from "../api/survey";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import { IconPlus } from "@tabler/icons-react";

function Surveys() {
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);
  const currentEventId = currentWorkspace.eventId;

  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1", 10);
  const [newRowSignal, setNewRowSignal] = useState(0);

  const setPage = (newPage) => setSearchParams({ page: newPage });

  const { data, isPending: isLoading } = useGetSurveys(
    currentEventId,
    page,
    10
  );

  const actions = useMemo(
    () => [
      {
        label: "Create",
        icon: <IconPlus />,
        onClick: () => setNewRowSignal((n) => n + 1),
      },
    ],
    []
  );

  useSetActionButtons(actions);

  return (
    <SurveyTable
      data={data}
      isLoading={isLoading}
      eventId={currentWorkspace.eventId}
      page={page}
      setPage={setPage}
      newRowSignal={newRowSignal}
    />
  );
}

export default Surveys;
